/**
 *In this example the shape property of the lightModeTheme object has been reduced to zero. This results in sharper corners being seen by the user.
 *
 * Some useful links for working with themes can be found at:
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/ //Will show all the properties you can edit
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563 //great for color selecting
 */

import { ThemeOptions } from '@material-ui/core';
import { defaultDarkTheme, AlmeTheme } from '../../../models/AlmeTheme';



const shape = {
    borderRadius: 0,
};

const lightModeTheme = { shape } as ThemeOptions;


export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: defaultDarkTheme,
} as AlmeTheme;
